<template>
  <PageView class="bg-light" header-class="bg-light" containerClass="d-flex flex-column flex-grow-1 align-items-center">
    <h3 class="card-title text-center mb-4" v-if="props.title">{{ props.title }}</h3>
    <iframe class="d-flex flex-grow-1 w-100" :src="`https://player.vimeo.com/video/${props.videoKey}?autoplay=1`" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
  </PageView>
</template>

<script lang="ts" setup>
  import PageView from '@/views/PageView.vue';

  const props = defineProps<{
    title: string,
    videoKey: string
  }>();
</script>
